module.exports = __webpack_public_path__ + "assets/img/shortsPlatform-anchor.2acec7a1.png";